// Product attribute types
export const PRODUCT_ATTRIBUTE_TYPES = {
    Flavor: 'Flavor',
    FlavorNote: 'FlavorNote',
    Finish: 'Finish',
    ProductionMethod: 'ProductionMethod',
    BaseIngredient: 'BaseIngredient',
    Body: 'Body',
    Aroma: 'Aroma',
    Color: 'Color',
    Texture: 'Texture',
    Sweetness: 'Sweetness',
    Bitterness: 'Bitterness',
    Acidity: 'Acidity',
    Tannin: 'Tannin',
    AlcoholContent: 'AlcoholContent',
} as const;
export type ProductAttributeType =
    (typeof PRODUCT_ATTRIBUTE_TYPES)[keyof typeof PRODUCT_ATTRIBUTE_TYPES];

export const FLAVOR_TYPES = {
    Acai: 'Acai',
    Apple: 'Apple',
    Apricot: 'Apricot',
    Banana: 'Banana',
    Blackberry: 'Blackberry',
    Blueberry: 'Blueberry',
    BlueRaspberry: 'Blue Raspberry',
    Butterscotch: 'Butterscotch',
    Cherry: 'Cherry',
    Chocolate: 'Chocolate',
    Cinnamon: 'Cinnamon',
    Citrus: 'Citrus',
    Coconut: 'Coconut',
    Cranberry: 'Cranberry',
    Cucumber: 'Cucumber',
    DragonFruit: 'Dragon Fruit',
    Elderflower: 'Elderflower',
    Espresso: 'Espresso',
    Ginger: 'Ginger',
    Grape: 'Grape',
    Grapefruit: 'Grapefruit',
    Hazelnut: 'Hazelnut',
    Honey: 'Honey',
    HoneyDew: 'Honeydew',
    Kiwi: 'Kiwi',
    Lemon: 'Lemon',
    Lemongrass: 'Lemongrass',
    Lime: 'Lime',
    Mango: 'Mango',
    Marshmallow: 'Marshmallow',
    Mint: 'Mint',
    Orange: 'Orange',
    PassionFruit: 'Passion Fruit',
    Peach: 'Peach',
    Pear: 'Pear',
    Pineapple: 'Pineapple',
    Pomegranate: 'Pomegranate',
    Raspberry: 'Raspberry',
    SmokedMaple: 'Smoked Maple',
    Strawberry: 'Strawberry',
    Tropical: 'Tropical',
    Vanilla: 'Vanilla',
    Watermelon: 'Watermelon',
};
export type FlavorType = (typeof FLAVOR_TYPES)[keyof typeof FLAVOR_TYPES];
